import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Card.module.css';

export type CardInfo = {
    title?: string;
    icon?: string;
    className?: string;
    children?: ReactNode;
};

export const Card: React.FC<CardInfo> = ({
    title,
    icon,
    className,
    children,
}) => {
    return (
        <div
            data-testid="universalCard"
            className={classNames(className, styles.universalCard)}
        >
            <CardHeader title={title} icon={icon} />
            {children}
        </div>
    );
};

export type CardHeaderInfo = {
    title?: string;
    icon?: string;
};

export const CardHeader: React.FC<CardHeaderInfo> = ({ title, icon }) => {
    return (
        <div className={classNames(styles.universalCardHeader)}>
            {icon && (
                <img
                    src={icon}
                    className={styles.universalCardIcon}
                    alt={title}
                />
            )}
            <div className={classNames(styles.universalCardHeaderText)}>
                <h2 className={classNames(styles.universalCardTitle)}>
                    {title}
                </h2>
                <p className={classNames(styles.universalCardDisclaimerLine)}>
                    If this is an emergency, please call 911.
                </p>
            </div>
        </div>
    );
};
